export default "__VITE_ASSET__CsqOWNV9__"